import Auth from 'j-toker';
import * as types from './actionTypes';
import { apiPostMultipart, apiPutMultipart, apiDelete } from 'helpers/ApiHelper';
import { deepDiver } from 'helpers/utilities';

const makeUrl = (path) => Auth.getApiUrl() + '/landlords' + path;

const buildFormData = (data) => {
  let multiPartFormData = new FormData();

  if (deepDiver(data, 'notice_image.lastModified')) {
    multiPartFormData.append('notice_image', data.notice_image);
  }

  if (deepDiver(data, 'new_attachments')) {
    data['new_attachments'].forEach((attachment, i) => {
      multiPartFormData.append('new_attachments[]', attachment);
    });
  }

  data = JSON.parse(JSON.stringify(data));

  if (Array.isArray(data['properties'])) {
    data['property_ids'] = data['properties'];
  } else {
    data['property_ids'] = [data['properties']];
  }

  data['allow_attachment_modify'] = data['allow_attachment_modify'] === true;
  data['allow_image_modify'] = data['allow_image_modify'] === true;

  const formData = JSON.stringify(data);

  multiPartFormData.append('data', formData);
  return multiPartFormData;
};

export function createNoticeTemplate(data) {
  return (dispatch) => {
    dispatch({ type: types.CREATE_NOTICE_TEMPLATE });

    const submitData = buildFormData(data);

    return apiPostMultipart(makeUrl('/notice_templates'), submitData);
  };
}

export function editNoticeTemplate(data, noticeTemplateId) {
  return (dispatch) => {
    dispatch({ type: types.EDIT_NOTICE_TEMPLATE });

    const submitData = buildFormData(data);

    return apiPutMultipart(makeUrl(`/notice_templates/${noticeTemplateId}`), submitData);
  };
}

export function deleteNoticeTemplate(noticeTemplateId) {
  return (dispatch) => {
    dispatch({ type: types.DELETE_NOTICE_TEMPLATE });

    return apiDelete(makeUrl(`/notice_templates/${noticeTemplateId}`));
  };
}
